(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.weaver_tailwind_tabs = {

    // for anchorOpenChecklist see weaver_tailwind_collapse.anchorOpenCollapse

    anchorOpenTab: function(url='') {
      if (url === '') {
        url = window.location.href;
      }
      const anchorPattern = /#ptb-tab-(\d+)/;
      const match = url.match(anchorPattern);

      if (!anchorPattern.test(url)) {
        return;
      }
      this.toggleTab(match[1]);
    },

    copyLink: function(link) {
      if (navigator.clipboard == undefined) {
        return;
      }

      navigator.clipboard.writeText(link.dataset.link);
      let spans = link.querySelectorAll('span');

      if (spans.length == 0) {
        return;
      }

      spans[0].classList.add('hidden');
      spans[1].classList.remove('hidden');
      setTimeout(() => {
        spans[1].classList.add('hidden');
        spans[0].classList.remove('hidden');
      }, 2000);
    },

    getBreakpoint: function() {
      return 1199;
    },

    getTabOfChecklist: function(checklist) {
      return checklist.closest('.tab-pane');
    },

    initializeCopyLinks: function() {
      const copyLinks = document.querySelectorAll('[data-effect="copy-link"]');
      if (copyLinks.length == 0) {
        return;
      }

      copyLinks.forEach((copyLink) => {
        copyLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.copyLink(copyLink);
        });
      });
    },

    initializeNextTabLinks: function(tabs, tabNextLinks) {
      if (tabs.length == 0 || tabNextLinks.length == 0) {
        return;
      }

      tabNextLinks.forEach((nextLink) => {
        nextLink.addEventListener('click', (e) => {
          this.toggleTab(nextLink.dataset.ptbTarget);
        });
      });
    },

    initializeScrollToChecklist: function() {
      const checklistLinks = document.querySelectorAll('[data-ptb-link="checklist"]');
      if (checklistLinks.length <= 0) {
        return;
      }

      checklistLinks.forEach((checklistLink) => {
        checklistLink.addEventListener('click', (e) => {
          let tab = this.getTabOfChecklist(checklistLink);
          this.scrollToChecklist(tab);
        });
      });
    },

    resetTabContent: function() {
      const tabContents = document.querySelectorAll('.tab-content');

      if (tabContents.length < 1) {
        return;
      }

      tabContents.forEach((tabContent) => {
        let tabsContainer = tabContent.closest('.paragraph--type--ptb-tabs').querySelector('.nav-tabs');

        if (tabsContainer == null) {
          return;
        }

        tabsContainer.after(tabContent);
      });
    },

    scrollToChecklist: function(tab) {

      // open tab if not already open
      if (tab.dataset.tweTabActive == undefined) {
        const tabId = tab.getAttribute('id').replace('ptb-tab-', '');
        this.toggleTab(tabId);
      }

      const checklist = tab.querySelector('.paragraph--type--ptb-checklist');

      if (checklist == null) {
        return;
      }

      const checklistCollapse = checklist.querySelector('[data-twe-collapse-item]');
      if (checklistCollapse == null) {
        return;
      }

      Drupal.behaviors.weaver_tailwind_collapse.openCollapse(checklistCollapse);

      // needs time to open tab before scrolling
      setTimeout(() => {
        checklist.scrollIntoView();
      }, 500);
    },

    toggleTab: function(targetTabId) {
      // open and scroll to tab
      const tabElement = document.getElementById('ptb-tablink-' + targetTabId);
      const tab = new twe.Tab(tabElement);
      tab.show();

      let tabContent = tabElement.parentNode;

      tabContent.scrollIntoView(true);
    },

    
    attach: function (context, settings) {

      $(once('weaver_tailwind_tabs', 'body', context)).each(function () {

        const weaver_tailwind_collapse = Drupal.behaviors.weaver_tailwind_collapse;
        const weaver_tailwind_tabs = Drupal.behaviors.weaver_tailwind_tabs;
        
        // checks if a tab anchor is present and opens the tab if so
        // needs timeout to give tabs time to initialize
        setTimeout(() => {
          weaver_tailwind_tabs.anchorOpenTab();
        }, 500);

        weaver_tailwind_tabs.initializeCopyLinks();
        // decided to disable and leave as regular tab order
        weaver_tailwind_tabs.initializeScrollToChecklist();

        const tabs = document.querySelectorAll('.tab-content .tab-pane');
        const tabNextLinks = document.querySelectorAll('.tab-next');
        weaver_tailwind_tabs.initializeNextTabLinks(tabs, tabNextLinks);
      });
    }
  };
})(jQuery, Drupal, once);
